<template>

    <FloatingPanel>

        <div class="shop::canvas-blocks-shop-products-BlockPanel">

            <Tabs :tabs="[
                'Product',
                'Opmaak',
            ]">

                <div slot="Product">
                    <SwitchInput
                        label="Populair of nieuwe producten?"
                        instruction=""
                        :options="options"
                        options-property="type"
                        :items="[
                                { value: 'populair', label: 'Populair'},
                                { value: 'new', label: 'Nieuwe producten'},
                            ]"
                        defaultValue="populair"
                        :open="true"
                    />
                </div>

                <div slot="Opmaak">
                    <CommonInputs
                        :options="options"
                    />
                </div>
            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";

export default {

    extends: AbstractPanel,

    components: {
        SwitchInput,
        FloatingPanel,
        CommonInputs,
        Tabs,
    },

}

</script>

<style lang="scss" scoped>

.shop\:\:canvas-blocks-shop-products-BlockPanel {

}

</style>
